import { Component, computed, inject, ViewChild } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { injectFullscreen } from 'src/app/_core/utils/inject-fullscreen';
import { ExternalVideoDialogFacade } from 'src/app/_core/state/dialogs/external-video/external-video.facade';
import { ExternalVideoData } from 'src/app/_core/state/dialogs/external-video/model/external-video-data.model';
import { DialogComponent } from 'src/app/_shared/components/dialog/dialog.component';

@Component({
  selector: 'opac-external-video-dialog',
  templateUrl: './external-video-dialog.component.html',
  styleUrls: ['./external-video-dialog.component.scss'],
})
export class ExternalVideoDialogComponent {
  private readonly externalVideoDialogFacade = inject(ExternalVideoDialogFacade);

  @ViewChild(DialogComponent) dialog!: DialogComponent;

  readonly externalVideoData = toSignal<ExternalVideoData>(this.externalVideoDialogFacade.externalVideoData$);
  readonly isOpen = toSignal<boolean>(this.externalVideoDialogFacade.open$);
  readonly fullscreen = injectFullscreen();
  readonly fullscreenIcon = computed(() => (this.fullscreen.isFullscreen() ? 'fullscreen_exit' : 'fullscreen'));
  readonly fullscreenLabel = computed(() =>
    this.fullscreen.isFullscreen() ? 'general.exitFullscreen' : 'general.fullscreen'
  );

  closeDialog() {
    if (this.fullscreen.isFullscreen()) {
      this.fullscreen.toggleFullscreen();
    }

    this.externalVideoDialogFacade.closeDialog();
  }

  toggleFullscreen() {
    this.fullscreen.toggleFullscreen(this.dialog.dialogEl.nativeElement);
  }
}
